import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {
  updateIssueMilestoneBulkByQueryRelayMutation,
  UpdateIssuesBulkByQueryInput,
} from './__generated__/updateIssueMilestoneBulkByQueryRelayMutation.graphql'

type issueUpdateArgs = {
  milestoneId: string | undefined
  clearMilestone: boolean | undefined
}

export function commitUpdateIssueMilestoneBulkByQueryMutation({
  environment,
  input: {query, repositoryId, milestoneId, clearMilestone},
  onCompleted,
  onError,
}: {
  environment: Environment
  input: {query: string; repositoryId: string} & issueUpdateArgs
  onCompleted?: (response: updateIssueMilestoneBulkByQueryRelayMutation['response']) => void
  onError?: (error: Error) => void
}) {
  const inputArgs = {milestoneId, clearMilestone}
  const inputHash: UpdateIssuesBulkByQueryInput = {
    query,
    repositoryId,
    ...inputArgs,
  }

  return commitMutation<updateIssueMilestoneBulkByQueryRelayMutation>(environment, {
    mutation: graphql`
      mutation updateIssueMilestoneBulkByQueryRelayMutation($input: UpdateIssuesBulkByQueryInput!) @raw_response_type {
        updateIssuesBulkByQuery(input: $input) {
          jobId
        }
      }
    `,
    variables: {
      input: inputHash,
    },
    onCompleted: response => onCompleted && onCompleted(response),
    onError: error => onError && onError(error),
  })
}
